export default __webpack_public_path__ + "static/pillars-retail-d109bc66235808bd26c63c62ba474a4b.png";